import { useEffect, useState } from "react"
import formatNumber from "@/lib/Common"
import dayjs from "@/lib/dayjs";
import { BidBadge } from "../Common/BidBadge"

export function BidBadgeWithCountdownSearch({
  targetTime,
  gunbroker_item_id,
  ...props
}) {
  const [currentTime, setCurrentTime] = useState(dayjs.utc())
  const [timeLeft, setTimeLeft] = useState(
    dayjs.duration(targetTime.diff(dayjs.utc()))
  )
  const [variant, setVariant] = useState()
  const [displayTime, setDisplayTime] = useState("")

  useEffect(() => {
    const interval = setInterval(() => {
      const now = dayjs.utc()
      setCurrentTime(now)
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    const newTimeBetween = dayjs.duration(targetTime.diff(currentTime))
    setTimeLeft(newTimeBetween)

    let badgeVariant = "default"
    if (newTimeBetween.asHours() < 24) {
      if (newTimeBetween.asHours() <= 0) {
        badgeVariant = "lastcall"
      } else if (newTimeBetween.asHours() < 2) {
        badgeVariant = "danger"
      } else {
        badgeVariant = "warning"
      }
    }

    setVariant(badgeVariant)
  }, [currentTime, targetTime])

  useEffect(() => {
    const time =
      timeLeft.asSeconds() >= 0
        ? timeLeft.days() > 0
          ? `${timeLeft.days()} day${timeLeft.days() > 1 ? "s left" : " left"}`
          : `${formatTimePart(timeLeft.hours())}:${formatTimePart(
              timeLeft.minutes()
            )}:${formatTimePart(timeLeft.seconds())}`
        : "Last Call"
    setDisplayTime(time)

    if (time === "Last Call") {
      // Retrieve the current array from localStorage or initialize an empty array
      const currentIds = JSON.parse(
        localStorage.getItem("lastCallGunbrokerIds") || "[]"
      )
      if (
        !currentIds.includes(gunbroker_item_id) &&
        gunbroker_item_id !== null
      ) {
        currentIds.push(gunbroker_item_id)
        localStorage.setItem("lastCallGunbrokerIds", JSON.stringify(currentIds))
      }
    }
  }, [timeLeft, gunbroker_item_id])

  const formatTimePart = (value) => {
    return value.toString().padStart(2, "0")
  }

  return (
    variant && (
      <BidBadge variant={variant} {...props}>
        <span className="flex items-center">
          <span
            className={`font-semibold tracking-[0.08px] ${
              displayTime.includes("left")
                ? "text-[10px]"
                : "text-[13px] -my-0.5"
            }`}
          >
            {displayTime}
          </span>
        </span>
      </BidBadge>
    )
  )
}
